import { RequestChangeResponse } from "@/service/response/admin-audit-logs";
import { formatDate } from "@/modules/common/utils/format";

interface LogChangeCardProps {
  change: RequestChangeResponse;
}

const LogChangeCard = ({ change }: LogChangeCardProps) => {
  const entries = change.translation ? Object.entries(change.translation) : null;

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-ui-border p-4">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="flex min-w-0 flex-col">
          <span className="text-sm font-semibold text-ui-primary wrap-break-word">
            {change.modelName ?? "-"}
            {change.modelId ? ` · ${change.modelId}` : ""}
          </span>
          <span className="text-xs text-ui-text-muted wrap-break-word">{change.operation ?? "-"}</span>
        </div>

        {change.startedAt && (
          <span className="text-xs text-ui-text-muted whitespace-nowrap">{formatDate(change.startedAt, "DD/MM/YYYY [às] HH:mm:ss")}</span>
        )}
      </div>

      {entries && entries.length > 0 ? (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {entries.map(([key, value]) => (
            <div key={key} className="flex min-w-0 flex-col gap-0.5 rounded-md bg-gray-50 p-2.5">
              <span className="text-xs font-semibold text-ui-text-muted">{key}</span>
              <span className="text-sm text-ui-text-dark wrap-break-word">{String(value ?? "-")}</span>
            </div>
          ))}
        </div>
      ) : (
        <pre className="overflow-x-auto rounded-md bg-gray-50 p-3 text-xs text-ui-text-dark whitespace-pre-wrap wrap-break-word">
          {JSON.stringify(change.changes ?? {}, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default LogChangeCard;
